export default __webpack_public_path__ + "static/media/Personalized_Learning.66438821.png";